import React from 'react';
import {Button, Icon} from '@lightricks/react-design-system';
import {styled} from '@mui/material';
import useIsMobile from '@/hooks/use-is-mobile';
import translate from '@/utils/translate';

interface FiltersButtonProps {
  onClick: () => void;
  isDirty?: boolean;
}

const shouldNotForwardProps = ['isDirty'];

const StyledFilterButton = styled(Button, {
  shouldForwardProp: (prop: string) => !shouldNotForwardProps.includes(prop),
})(({isDirty}: {isDirty?: boolean}) => ({
  'border': isDirty ? `2px solid #000000` : `1px solid #D9D9D9`,
  'borderRadius': '5px',
  'padding': '10px 15px',
  'height': '43px',
  'color': 'rgba(64, 64, 64, 1)',
  'fontSize': '17px',
  'lineHeight': '19px',
  'fontWeight': 400,
  'backgroundColor': 'transparent',
  'position': 'relative',
  '&:hover': {
    backgroundColor: 'transparent',
    opacity: 1,
  },
}));

const DirtyIndicator = styled('div')(() => ({
  position: 'absolute',
  width: '11px',
  height: '11px',
  borderRadius: '50%',
  backgroundColor: '#000',
  border: '2px solid #fff',
  top: '-5px',
  right: '-5px',
  zIndex: 1,
}));

const ButtonContainer = styled('div')(() => ({
  position: 'relative',
  display: 'inline-block',
}));

function FiltersButton({onClick, isDirty}: FiltersButtonProps) {
  const isMobile = useIsMobile();
  return (
    <ButtonContainer>
      <StyledFilterButton
        onClick={onClick}
        appearance="neutral"
        mode="plain"
        size="medium"
        isDirty={Boolean(isDirty)}
        iconPosition="start"
        icon={
          <Icon size="medium" appearance="neutral" name="Features-Edit-Full" />
        }
      >
        {!isMobile && translate('Filters')}
      </StyledFilterButton>
      {isDirty && <DirtyIndicator />}
    </ButtonContainer>
  );
}

export default FiltersButton;
